import React, { useCallback, useEffect, useRef, useState } from "react"
import AdminOfferBlock from "components/shared/AdminOfferBlock"
import { AdminOffersService } from "services/api-service"
import { AdminOfferType } from "services/api-service/types"
import { SentryService } from "services/SentryService"
import styled from "styled-components"
import { Box, Row } from "ui/components/atoms/_atoms"
import Input from "ui/components/atoms/input"
import Spinner from "ui/components/atoms/spinner"
import { Pagination } from "ui/components/molecules/pagination"

const OffersList = () => {
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [data, setData] = useState<AdminOfferType[]>([])
  const [q, setQ] = useState<string | null>(null)
  const firstRender = useRef<boolean>(true)
  const timeoutId = useRef<NodeJS.Timeout | null>(null)

  const fetchOffers = useCallback(
    async (newPage: number) => {
      try {
        setLoading(true)
        const { content, totalPages } = await AdminOffersService.getOffers(
          q,
          null,
          null,
          newPage,
          15,
        )
        setData(content)
        setTotalPages(totalPages)
      } catch (e) {
        SentryService.error("[ERROR AdminProfileService.getOffers]:", e)
      } finally {
        setLoading(false)
      }
    },
    [q],
  )

  useEffect(() => {
    fetchOffers(page)
  }, [fetchOffers, page])

  const handleOnRefresh = useCallback(() => {
    setPage(0)
    fetchOffers(0)
  }, [fetchOffers])

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }

    if (timeoutId.current) {
      clearTimeout(timeoutId.current)
    }

    timeoutId.current = setTimeout(() => {
      handleOnRefresh()
    }, 1000)
  }, [handleOnRefresh, q])

  return (
    <Wrapper>
      <FiltersWrapper $marginBottom="M">
        <Input
          name="q"
          label="Szukaj"
          placeholder="np. nazwa ID ogłoszenia lub nazwa"
          value={q ?? ""}
          onChange={({ value }) => setQ(value)}
        />
      </FiltersWrapper>
      {loading && (
        <Row $justifyContent="center">
          <Spinner $size="30px" />
        </Row>
      )}
      {!loading && data.map(el => <AdminOfferBlock key={el.id} data={el} />)}
      {!loading && data.length > 0 && (
        <Pagination defaultPage={page + 1} totalPages={totalPages} onChange={e => setPage(e - 1)} />
      )}
    </Wrapper>
  )
}

export default OffersList

const FiltersWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  grid-gap: ${({ theme }) => theme.space.S};
`

const Wrapper = styled(Box)`
  padding: ${({ theme }) => theme.space.M} 0;
  display: flex;
  flex-direction: column;
  grid-gap: ${({ theme }) => theme.space.XS};
`
